import HeroCarousel from './components/HeroCarousel';
import VideoHero from './components/VideoHero';
import Accordion from './components/Accordion';
import { createVideoPlayer } from 'common/utils/video';
import Waypoint from 'waypoints/lib/noframework.waypoints';
import animateDinosaur from './components/dinosaur';
import { once } from 'lodash';
import createScrollableElements, {
    centerAlignScrollableElement,
    scrollOnHover,
} from './components/scrollable';
import { trackLink } from '@99designs/utils/platform';
import ScrollDepthTracking from 'marketing/utils/ScrollDepthTracking';

// Event tracking
document.addEventListener('DOMContentLoaded', () => {
    const enterpriseCTA = document.querySelector('[data-home-enterprise-cta]');

    if (enterpriseCTA) {
        trackLink(enterpriseCTA, 'Clicked Home Enterprise CTA');
    }
});

// Track scroll position
document.addEventListener('DOMContentLoaded', () => {
    new ScrollDepthTracking('Home Page');
});

document.addEventListener('DOMContentLoaded', () => {
    const carouselElement = document.querySelector('[data-carousel]');

    HeroCarousel.create({
        intervalTime: parseInt(carouselElement.getAttribute('data-carousel-interval'), 10),
        delayTime: parseInt(carouselElement.getAttribute('data-carousel-delay'), 10),
        hoverPauseElements: document.querySelectorAll('[data-hero-carousel-hover-pause-element]'),
    }).start();

    // Lazy-load images
    const lazyImages = document.querySelectorAll('[data-src]');

    for (var i = 0; i < lazyImages.length; i++) {
        const image = lazyImages[i];

        image.setAttribute('src', image.getAttribute('data-src'));
    }

    // Animate dinosaur interject when element comes into view.
    new Waypoint({
        element: document.querySelector('[data-dino]'),
        handler: once(() => {
            animateDinosaur(500);
        }),
        offset: '100%',
    });

    createScrollableElements();
    scrollOnHover('[data-scrollable]');

    centerAlignScrollableElement('[data-scrollable="examples"]').then(el => {
        const designCards = document.querySelectorAll('[data-design-card]');

        for (var i = 0; i < designCards.length; i++) {
            designCards[i].style.visibility = 'visible';
        }
    });

    createVideoPlayer();

    // Accordions
    Accordion.create();

    VideoHero.create();
});



// WEBPACK FOOTER //
// ./js/marketing/home.js